import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enCommon from 'commons/locales/en/common.json';
import esCommon from 'commons/locales/es/common.json';
import frCommon from 'commons/locales/fr/common.json';
import ptCommon from 'commons/locales/pt/common.json';

// Initialize i18n with localStorage persistence
const storedLanguage = localStorage.getItem('i18n_language');

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: storedLanguage || undefined, // Use stored language if available, otherwise auto-detect
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {translation: enCommon},
      es: {translation: esCommon},
      fr: {translation: frCommon},
      pt: {translation: ptCommon},
    },
  });

// Persist language changes to localStorage
i18n.on('languageChanged', language => {
  localStorage.setItem('i18n_language', language);
});

export const changeLanguage = (lng: string) => {
  i18n.changeLanguage(lng);
};

export default i18n;
